// Note: We can not use SecureRoute from Okta in react-router-dom v6. We need to create our own SecureRoute component.
import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useLocation } from 'react-router-dom';
import { toRelativeUrl } from '@okta/okta-auth-js';
interface SecureRouteProps {
  children: React.ReactElement;
}
const SecureRoute: React.FC<SecureRouteProps> = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();

  const originalUrl = toRelativeUrl(location.pathname, window.location.origin);
  const fullUrl = `${originalUrl}${location.search || ''}`

  if (!authState || authState.isPending) {
    return <div>Loading...</div>;
  }

  if (!authState.isAuthenticated) {
    oktaAuth.setOriginalUri(fullUrl);
    oktaAuth.signInWithRedirect();
    return <></>
  }

  return children;
};
export default SecureRoute;
